import * as React from 'react'
import { observer } from 'mobx-react'

import { Section, SectionItem } from '../../components/Section'
import SpousalProfileViewModel from '../SpousalProfile/SpousalProfileViewModel'
import EditPersonalProfileDialogViewModel from 'jobs/views/JobRoot/Job/CapturedInformationCard/EditPersonalProfileDialog/EditPersonalProfileDialogViewModel'
import Button from 'components/Button'

interface Props {
  vm: SpousalProfileViewModel
  editVM?: EditPersonalProfileDialogViewModel
  canEdit?: boolean
}

export default observer(function SpousalProfile({
  vm,
  editVM,
  canEdit,
}: Props) {
  if (!vm.spousalInfoSupportingItem) {
    return <></>
  }

  if (!vm.profile) {
    return <></>
  }

  const editable = Boolean(canEdit && editVM)

  return (
    <div>
      <Section
        title="Spousal Information"
        bordered
        loading={vm.activate.pending}
        actions={
          editable && editVM ? (
            <Button
              type="text"
              onClick={() => editVM.show('spousal')}
              data-test="update-spousal-information-button"
            >
              Edit
            </Button>
          ) : undefined
        }
      >
        <SectionItem
          label="Name"
          value={vm.profile?.personalInfo?.fullName}
          isSensitive
        />

        <SectionItem
          label="Date of birth"
          value={vm.profile?.personalInfo?.dateOfBirth}
          isSensitive
        />

        <SectionItem
          label="Occupation"
          value={vm.profile?.occupation}
          isSensitive
        />

        {vm.profile?.contactInfo?.email && (
          /* For spouses we only really care about the e-mail. The backend supports collecting
            the whole contact info, but in practice only the email is used. This was done to maintain
            consistency in the API shapes, and in case they change their minds about additional contact
            info in the future. */
          <SectionItem
            label="Email address"
            value={vm.profile?.contactInfo?.email}
            isSensitive
          />
        )}

        <SectionItem
          label="SSN or ITIN"
          value={vm.profile?.personalInfo?.personalTaxpayerIdentificationNumber}
          maskedValue={
            vm.profile?.personalInfo
              ?.personalTaxpayerIdentificationNumberDisplay
          }
          isSensitive
        />
      </Section>
    </div>
  )
})
